import * as React from 'react';

import { Ii18n } from '../../../../store/utils/contracts/i18n.interface';
import { StaticInformation } from '../../../custom/static-information';
import { getI18n } from '../../../../store/utils/i18n/strings.manager';
import styles from './responsibleParty.module.css';
import { CaseResponse } from '../../../../store/case/model';

interface ResponsiblePartyProps {
  readonly case: CaseResponse;
  readonly header: string;
}
interface PolicyInfoElements {
  [key: string]: any;
}
class ResponsiblePartyComponent extends React.Component<ResponsiblePartyProps> {
  private localization: Ii18n;

  constructor(props: ResponsiblePartyProps) {
    super(props);
    this.localization = getI18n();
  }

  render() {
    const propertiesUsed = ['responsibleInsurerCaseNumber',
                            'responsiblePartyLicensePlate',
                            'responsiblePartyPolicyType',
                            'responsiblePartyInsurerName', ];

    const policyInfoElements = Object.keys(this.props.case)
                            .filter(key => propertiesUsed.includes(key))
                            .reduce((obj: PolicyInfoElements, key) =>  {
                              obj[key] = this.props.case[key];
                              return obj;
                             }, {} as PolicyInfoElements);

    const numberOfElements = Object.values(policyInfoElements).filter(x => x && x !== 'Unknown').length;

    if (numberOfElements === 0) {
      return null;
    }


    return (
      <div className={styles.container}>
        <h2>{this.localization.get(this.props.header)}</h2>
        <div className={styles.static}>
          <div className={styles.staticContent}>
            <StaticInformation
              translation='details.case.responsibleParty'
              headerText=''
              information={{
                'caseNumber': this.props.case.responsibleInsurerCaseNumber,
                'licencePlate': this.props.case.responsiblePartyLicensePlate,
                'policyType': this.props.case.responsiblePartyPolicyType,
                'insurerName': this.props.case.responsiblePartyInsurerName
              }} />
          </div>
        </div>
      </div>
    );
  }
}

export { ResponsiblePartyComponent };
